import { OidcSimpleClient } from './auth/OidcSimpleClient';
export const authClientInstance = new OidcSimpleClient();
